import { Flex } from '@applyboard/crystal-ui';

import { ProgramDetailsHeading } from '../components/ProgramDetailsHeading';
import { ProgramInformation } from '../components/ProgramInformation';

export function TabletLayout() {
  return (
    <Flex p={6} gap={6} direction="column">
      <ProgramDetailsHeading />
      <ProgramInformation />
    </Flex>
  );
}
